
import React, { Component } from 'react';
import { Modal } from 'react-bootstrap'

// import FontAwesome from 'react-fontawesome'
import InsurerPage from './InsurerPage'



class InsurerPageModal extends Component {

  constructor(...args) {
    super(...args)
    this.state = {}

    //this.openPopup() 
  }

  openPopup() {
    // console.log("ref", this.refs.swtCustPop)
    //this.refs.swtInsurPage.loadPage()
  }

  onSelectInsurerItem(item) {
    if (typeof this.props.onSelect !== 'undefined') {
      this.props.onSelect(item)
    } else {
      window.onSelectInsurerItem(item)
    }
    this.props.onHide()
  }

  render() {
    let { show, showNew } = this.props

    return (
      <Modal show={show} enforceFocus={false} onHide={this.props.onHide} dialogClassName="midwidth-dialog">
        <Modal.Header closeButton>
          <Modal.Title>{'ค้นหาบริษัทประกัน'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <InsurerPage ref={'swtInsurPage'} showNew={showNew} onChange={this.props.onChange} onSelectItem={this.onSelectInsurerItem.bind(this)} />
        </Modal.Body>
        <Modal.Footer>
        </Modal.Footer>
      </Modal>
    )
  }
}


export default InsurerPageModal;





// WEBPACK FOOTER //
// ./src/view/insurer/InsurerPageModal.js